import { render, staticRenderFns } from "./px-questionary-criteria.vue?vue&type=template&id=6cb79b5a&scoped=true&"
import script from "./px-questionary-criteria.vue?vue&type=script&lang=ts&"
export * from "./px-questionary-criteria.vue?vue&type=script&lang=ts&"
import style0 from "./px-questionary-criteria.vue?vue&type=style&index=0&id=6cb79b5a&lang=scss&scoped=true&"
import style1 from "./px-questionary-criteria.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb79b5a",
  null
  
)

export default component.exports